
function readCookie(name) {
  const cookieArr = document.cookie.split(";");
  for (const cookie of cookieArr) {
    const eqIdx = cookie.indexOf("=");
    if (eqIdx === -1) continue;
    const cookieName = cookie.substring(0, eqIdx).trim();
    if (name === cookieName) {
      return decodeURIComponent(cookie.substring(eqIdx + 1));
    }
  }
  return null;
}

export { readCookie };
